/**
 * Defensive readers for the IELTS JSON fields that the OpenAPI schema leaves open (D-105): a
 * missing or malformed field never throws, it falls back to an empty value. Internal to the module.
 */

export type Json = Record<string, unknown>;

export function isObject(value: unknown): value is Json {
  return typeof value === "object" && value !== null && !Array.isArray(value);
}

/** A string (a number is written out, anything else is empty). */
export function str(value: unknown, fallback = ""): string {
  return typeof value === "string" ? value : typeof value === "number" && Number.isFinite(value) ? String(value) : fallback;
}

/** A finite number, or the fallback. */
export function num(value: unknown, fallback = 0): number {
  return typeof value === "number" && Number.isFinite(value) ? value : fallback;
}

/** A finite number, or null (a value not measured yet). */
export function numOrNull(value: unknown): number | null {
  return typeof value === "number" && Number.isFinite(value) ? value : null;
}

export function strings(value: unknown): string[] {
  return Array.isArray(value) ? value.map((v) => str(v)) : [];
}

export function numbers(value: unknown): number[] {
  return Array.isArray(value) ? value.filter((n): n is number => typeof n === "number" && Number.isFinite(n)) : [];
}

export function objects(value: unknown): Json[] {
  return Array.isArray(value) ? value.filter(isObject) : [];
}
